import { Form220 } from "../components/form220/Form220";

const Page = (props) => {
  return <Form220 {...props} />;
};

export default Page;
